import type { WalletGroupedAccounts } from '@polaris/core/models'
import { motion } from 'motion/react'
import { useState } from 'react'
import { cn } from '@/src/utils/styles'
import { AccountCard } from '../accounts/account-card'

export function WalletStack({
  onClick,
  wallets,
  customLayoutId,
}: {
  onClick?: () => void
  wallets: WalletGroupedAccounts[]
  customLayoutId?: string
}) {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <div className='flex flex-grow relative min-h-[92px] min-w-[168px]'>
      <motion.button
        type='button'
        onHoverStart={() => setIsHovered(true)}
        onHoverEnd={() => setIsHovered(false)}
        disabled={wallets.length === 0}
        onClick={onClick}
        className='basis-[168px] h-[92px] flex justify-start focus-outer rounded-2xl'
      >
        <div
          className={cn(
            'peer absolute top-0 z-[6] flex flex-col justify-end gap-2 min-h-[92px] min-w-[168px] px-3 pb-2 rounded-2xl bg-foreground hover:bg-surface1-100 hover:-translate-y-1 shadow-lg hover:shadow-xl transition-all',
          )}
        >
          <div className='flex flex-col items-start'>
            <span className='text-sm text-primary font-semibold'>
              {wallets.length} wallet{wallets.length > 1 && 's'}
            </span>
            <span className='text-sm text-link'>Manage</span>
          </div>
        </div>
      </motion.button>
      {wallets.slice(0, 5).map((acc, i) => {
        const index = i + 1
        return (
          <div
            className='flex-grow h-[92px] max-w-3 flex justify-end'
            key={customLayoutId || `wallet-${index}`}
          >
            <AccountCard
              account={acc}
              className='absolute h-full top-0 shadow-[3px_0_4px_-3px_rgba(0,0,0,18%)]'
              onHoverStart={() => setIsHovered(true)}
              onHoverEnd={() => setIsHovered(false)}
              style={{
                zIndex: -index,
                originX: 0.5,
                originY: 0.5,
              }}
              animate={{
                y: isHovered ? -8 : 0,
                rotate: isHovered ? Math.min((12 / wallets.length) * index) : 0,
                zIndex: -index,
              }}
            />
          </div>
        )
      })}
    </div>
  )
}
